import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phone = control.value;
    if (!phone) {
      return null;
    }
    // Remove spaces and dashes for validation purposes
    const sanitizedPhone = phone.replace(/[\s-]/g, '');

    // Swedish telephone numbers:
    // - 8 to 10 digits for national numbers
    // - Start with 0 for national or +46/0046 for international
    // - Mobile numbers start with 07
    const swedenPattern = /^0[1-9]\d{7,9}$|^(0?7[0-9]\d{7})$|^(\+46|0046)[1-9]\d{1,2}\d{6,7}$/;

    const valid = swedenPattern.test(sanitizedPhone);
    return valid ? null : {invalidPhone: true};
  };
}
